import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import './IosTechnologies.css';

const technologies = {
  "Languages": [
    { 
      name: "Swift",
      logo: "/assets/tech-logos/swift-external.svg",
      fallbackLogo: "/assets/tech-logos/swift.svg"
    },
    { 
      name: "Objective-C",
      logo: "/assets/tech-logos/objectivec-external.svg",
      fallbackLogo: "/assets/tech-logos/objectivec.svg"
    }
  ],
  "Frameworks": [
    { 
      name: "SwiftUI",
      logo: "/assets/tech-logos/swiftui-external.png",
      fallbackLogo: "/assets/tech-logos/swiftui.svg"
    },
    { 
      name: "UIKit",
      logo: "/assets/tech-logos/uikit-external.png",
      fallbackLogo: "/assets/tech-logos/uikit.svg"
    },
    { 
      name: "Core Data",
      logo: "/assets/tech-logos/coredata.svg",
      fallbackLogo: "/assets/tech-logos/coredata.svg"
    }
  ],
  "Platforms": [
    { 
      name: "iOS",
      logo: "/assets/tech-logos/apple-external.svg",
      fallbackLogo: "/assets/tech-logos/apple.svg"
    },
    { 
      name: "iPadOS",
      logo: "/assets/tech-logos/apple-external.svg",
      fallbackLogo: "/assets/tech-logos/apple.svg"
    },
    { 
      name: "macOS",
      logo: "/assets/tech-logos/apple-external.svg",
      fallbackLogo: "/assets/tech-logos/apple.svg"
    }
  ],
  "Development Tools": [
    { 
      name: "Xcode",
      logo: "/assets/tech-logos/xcode-external.png",
      fallbackLogo: "/assets/tech-logos/xcode.svg"
    },
    { 
      name: "CocoaPods",
      logo: "/assets/tech-logos/cocoapods.svg",
      fallbackLogo: "/assets/tech-logos/cocoapods.svg"
    },
    { 
      name: "TestFlight",
      logo: "/assets/tech-logos/testflight-external.png",
      fallbackLogo: "/assets/tech-logos/testflight.png"
    },
    { 
      name: "Firebase",
      logo: "/assets/tech-logos/firebase-external.svg",
      fallbackLogo: "/assets/tech-logos/firebase.svg"
    }
  ]
};

const IosTechnologies = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const handleImageError = (e, fallbackSrc) => {
    if (e.target.src !== fallbackSrc) {
      e.target.src = fallbackSrc;
    }
  };

  return (
    <Box className="ios-technologies-section">
      <Container maxWidth="lg">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            iOS
          </Typography>

          {Object.entries(technologies).map(([category, techs]) => (
            <Box key={category} className="technology-category">
              <Typography variant="h4" className="category-title" gutterBottom>
                {category}
              </Typography>
              <Grid container spacing={3}>
                {techs.map((tech) => (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={tech.name}>
                    <motion.div variants={itemVariants}>
                      <Paper elevation={2} className="technology-card">
                        <img
                          src={tech.logo}
                          alt={tech.name}
                          className="technology-logo"
                          onError={(e) => handleImageError(e, tech.fallbackLogo)}
                        />
                        <Typography variant="subtitle1" className="technology-name">
                          {tech.name}
                        </Typography>
                      </Paper>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </motion.div>
      </Container>
    </Box>
  );
};

export default IosTechnologies; 